import { DefaultTheme } from '../../../components/theme';

export const CSS = {
	container: 'c-ExportNotificationDetail',
	field: 'c-ExportNotificationDetail__Field',
	form: 'c-ExportNotificationDetail__Form',
	reason: 'c-ExportNotificationDetail__Reason',
	default: 'c-ExportNotificationDetail__Default',
};

export const Style = {
	[CSS.field]: {
		'font-weight': DefaultTheme.font.weight.bold,
	},
};
